/* eslint-disable */
export default {
  ['CHANGE_LNG'](state) {
    state.lng = state.lng === 'ua' ? 'en' : 'ua';
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js